<template>
    <div>
        <div class="field">
            <label class="label">{{ translate("discipline_packages.mma_number_of_rounds") }}</label>
            <div class="control">
                <div class="select">
                    <select v-model="numberOfRounds">
                        <option :value="null">
                            {{ translate("discipline_packages.mma_number_of_rounds_judge_chooses") }}
                        </option>
                        <option v-for="n in [1, 2, 3]" :key="n" :value="n">{{ n }}</option>
                    </select>
                </div>
            </div>
        </div>

        <div v-if="showBreakBetweenRounds" class="field">
            <label class="label">{{ translate("discipline_packages.mma_break_between_rounds") }}</label>
            <div class="control">
                <div class="select">
                    <select v-model="breakBetweenRounds">
                        <option v-for="option in breakBetweenRoundsOptions" :key="option.labelTranslationKey" :value="option.value">
                            {{ translate(option.labelTranslationKey) }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { translate } from "../../Common/translations";
    import { useDisciplinePackagesStore } from "../disciplinePackagesStore";
    import { ScoreboardSettings } from "../../Api/disciplinePackages";
    import {
        getBreakBetweenRoundsForRoundsChange,
        normalizeBreakBetweenRoundsSelection,
        MMA_BREAK_BETWEEN_ROUNDS_OPTIONS,
        MmaBreakBetweenRoundsValue,
        shouldShowBreakBetweenRounds,
    } from "./mmaBreakBetweenRounds";

    const store = useDisciplinePackagesStore();
    const breakBetweenRoundsOptions = MMA_BREAK_BETWEEN_ROUNDS_OPTIONS;

    function updateActiveScoreboardSettings(settings: ScoreboardSettings): void {
        if (store.activeTabIndex !== null) {
            store.disciplineOverrideConfigs[store.activeTabIndex].scoreboardSettings = settings;
            return;
        }

        store.disciplineDefaultConfig.scoreboardSettings = settings;
    }

    const numberOfRounds = computed({
        get: () => store.activeScoreboardSettings.numberOfRounds ?? null,
        set: (value: number | null) => {
            const current = store.activeScoreboardSettings;

            updateActiveScoreboardSettings({
                ...current,
                numberOfRounds: value,
                breakBetweenRounds: getBreakBetweenRoundsForRoundsChange(value, current.breakBetweenRounds, current.numberOfRounds ?? null),
            } satisfies ScoreboardSettings);
        },
    });

    const showBreakBetweenRounds = computed(() => shouldShowBreakBetweenRounds(numberOfRounds.value));

    const breakBetweenRounds = computed({
        get: () => normalizeBreakBetweenRoundsSelection(store.activeScoreboardSettings.breakBetweenRounds),
        set: (value: MmaBreakBetweenRoundsValue) => {
            const current = store.activeScoreboardSettings;

            updateActiveScoreboardSettings({
                ...current,
                breakBetweenRounds: normalizeBreakBetweenRoundsSelection(value),
            });
        },
    });
</script>

<style scoped></style>
